<app-resp-popup-title>
  <mat-icon>folder</mat-icon>
  @if (formCanBeEdited) {
    <span
      i18n="Ordner bearbeiten@@InfoPortal_FolderUpdate_TitleEdit"
      >
    Edit Folder
  </span>
  }
  @if (!formCanBeEdited) {
    <span
      i18n="Ordner @@InfoPortal_FolderUpdate_TitleDetails"
      >
    Folder Details
  </span>
  }
</app-resp-popup-title>
<app-resp-popup-content>
  <div style="width: 500px; max-width: 100%; position: relative; min-height: 350px;">
    @if (form && !loading) {
      <form [formGroup]="form">
        <fieldset>
          <div class="row">
            <div class="col">
              <frm-text
                i18n-label="@@Infoportal_AddFolder_Description"
                label="Description"
                formControlName="bezeichnung"
                [readonly]="!formCanBeEdited"
                >
              </frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-text
                multiline="true"
                rows="5"
                formControlName="info"
                i18n-label="@@Infoportal_AddFolder_Info"
                label="Info"
                [readonly]="!formCanBeEdited"
                >
              </frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-infoportal-tags-select
                formControlName="tagIDs"
                [readonly]="!formCanBeEdited"
              ></frm-infoportal-tags-select>
            </div>
          </div>
          @if (hasDocuments) {
            <div class="row">
              <div class="col">
                <mat-label
                  style="font-size: smaller"
                  i18n="@@Infoportal_SetDocumentVisbility_Label"
                  >Set visibility of contained documents</mat-label
                  ><br />
                  <mat-button-toggle-group
                    formControlName="setDocumentVisibility"
                    [disabled]="!formCanBeEdited"
                    >
                    <mat-button-toggle [value]="documentVisibilitySettings.NoChanges">
                      <span
                        style="font-size: smaller"
                        i18n="@@Infoportal_ChangeDocumentVisbility_NoChanges"
                        >No Changes</span
                        >
                      </mat-button-toggle>
                      <mat-button-toggle
                        [value]="documentVisibilitySettings.SetAllInternalOnly"
                        >
                        <span
                          style="font-size: smaller"
                          i18n="@@Infoportal_ChangeDocumentVisbility_SetAllInternalOnly"
                          >internal only</span
                          >
                        </mat-button-toggle>
                        <mat-button-toggle
                          [value]="documentVisibilitySettings.SetAllExternalAndInternal"
                          >
                          <span
                            style="font-size: smaller"
                  i18n="
                    @@Infoportal_ChangeDocumentVisbility_SetAllExternalAndInternal"
                            >internal and external</span
                            >
                          </mat-button-toggle>
                        </mat-button-toggle-group>
                      </div>
                    </div>
                  }
                </fieldset>
              </form>
            } @else {
              <app-shimmer [isLoading]="true" type="custom">
                <ng-template shimmerPreviewTemplate>
                  <app-shimmer-label></app-shimmer-label>
                  <app-shimmer-input></app-shimmer-input>
                  <app-shimmer-label></app-shimmer-label>
                  <app-shimmer-input height="170px"></app-shimmer-input>
                  <app-shimmer-input height="78px"></app-shimmer-input>
                </ng-template>
              </app-shimmer>
            }
            @if (!formCanBeEdited && !loading) {
              <button
                mat-fab
                style="position: absolute; right: 14px; bottom: 10px"
                color="default"
                (click)="toggleFormCanBeEdited()"
                i18n-title="@@InfoPortal_FolderUpdate_BuChangeToEditMode"
                title="Change to edit mode"
                >
                <mat-icon>edit</mat-icon>
              </button>
            }
          </div>
        </app-resp-popup-content>
        @if (formCanBeEdited) {
          <app-resp-popup-actions>
            @if (!loading) {
              <div>
                <ctrl-btn-accept
                  [disabled]="!form.valid"
                  (click)="onAccept()"
                ></ctrl-btn-accept>
                <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
              </div>
            } @else {
              <app-shimmer [isLoading]="true" type="custom">
                <ng-template shimmerPreviewTemplate>
                  <app-shimmer-input
                    width="200px"
                    style="display: inline-block"
                  ></app-shimmer-input>
                  <app-shimmer-input
                    width="200px"
                    style="display: inline-block"
                  ></app-shimmer-input>
                </ng-template>
              </app-shimmer>
            }
          </app-resp-popup-actions>
        }


